import Settings from './Settings';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';

export default {
  list: Settings,
  icon: SettingsOutlinedIcon
};